import type {
  CreateGrowthStepRequest,
  GrowthReportEntryResponse,
  GrowthStepResponse,
  PersonGrowthProgressResponse,
  SetPersonGrowthStepRequest,
  UpdateGrowthStepRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const growthApi = {
  listSteps(includeArchived = false, signal?: AbortSignal) {
    return apiRequest<readonly GrowthStepResponse[]>('/people/growth/steps', {
      query: { includeArchived },
      signal,
    });
  },

  createStep(body: CreateGrowthStepRequest) {
    return apiRequest<GrowthStepResponse>('/people/growth/steps', { method: 'POST', body });
  },

  updateStep(stepId: string, body: UpdateGrowthStepRequest) {
    return apiRequest<GrowthStepResponse>(`/people/growth/steps/${stepId}`, {
      method: 'PATCH',
      body,
    });
  },

  archiveStep(stepId: string) {
    return apiRequest<GrowthStepResponse>(`/people/growth/steps/${stepId}/archive`, {
      method: 'POST',
    });
  },

  restoreStep(stepId: string) {
    return apiRequest<GrowthStepResponse>(`/people/growth/steps/${stepId}/restore`, {
      method: 'POST',
    });
  },

  report(signal?: AbortSignal) {
    return apiRequest<readonly GrowthReportEntryResponse[]>('/people/growth/report', { signal });
  },

  getProgress(personId: string, signal?: AbortSignal) {
    return apiRequest<PersonGrowthProgressResponse>(`/people/${personId}/growth`, { signal });
  },

  setProgress(personId: string, body: SetPersonGrowthStepRequest) {
    return apiRequest<PersonGrowthProgressResponse>(`/people/${personId}/growth`, {
      method: 'POST',
      body,
    });
  },
};
